// extracted by mini-css-extract-plugin
export default {"CenterMaxWidthContainer":"CenterMaxWidth_CenterMaxWidthContainer__l333R","CenterMaxWidth":"CenterMaxWidth_CenterMaxWidth__E12f3"};